import { useRouter } from "next/router";
import React from "react";
import { useIntl } from "react-intl";

const Banner = ({ title, currentPage }) => {
    const intl = useIntl();
    const router = useRouter();

    const goHome = () => {
        router.push("/");
    };

    return (
        <div className="banner">
            <div className="banner-content">
                <div className="wrapper">
                    <div className="banner-title">{title}</div>
                    <ul className="breadcrumbs">
                        <li>
                            <a href="#" onClick={goHome}>
                                {intl.messages.home}
                            </a>
                        </li>
                        <li>
                            <span>{currentPage}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Banner;
